import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white border border-1 rounded p-3 mb-3" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_3 = { class: "fs-5 lh-sm text-white bg-gray rounded m-0 px-2 py-1" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "row row-all" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "row mb-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!
  const _component_SelectBrands = _resolveComponent("SelectBrands")!
  const _component_SelectCategories = _resolveComponent("SelectCategories")!
  const _component_ProductList = _resolveComponent("ProductList")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('labsBrandsAndCategories').toUpperCase()), 1),
      _createVNode(_component_BaseDeleteButton, {
        deleteData: _ctx.removeCondition,
        pageUI: _ctx.pageUI,
        class: "btn-sm"
      }, null, 8, ["deleteData", "pageUI"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_SelectBrands, {
              "selected-brand-codes": _ctx.brandCodes,
              class: "col-11",
              onAddBrand: _ctx.addBrand,
              onRemoveBrand: _ctx.removeBrand
            }, null, 8, ["selected-brand-codes", "onAddBrand", "onRemoveBrand"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_SelectCategories, {
              "selected-product-categories": _ctx.categoryCodes,
              class: "col-11",
              onAddCategory: _ctx.addCategory,
              onRemoveCategory: _ctx.removeCategory
            }, null, 8, ["selected-product-categories", "onAddCategory", "onRemoveCategory"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_ProductList, {
            "model-value": _ctx.productSelection,
            "onUpdate:modelValue": _ctx.updateExcludedProducts,
            height: 300,
            name: "excludedBrandtProducts",
            "field-label": _ctx.$t('productsExcluded'),
            errors: _ctx.errors
          }, null, 8, ["model-value", "onUpdate:modelValue", "field-label", "errors"])
        ])
      ])
    ])
  ]))
}